// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__fYegZ","header":"ReportDetails_header__2ykIz","title":"ReportDetails_title__-hoMg","left":"ReportDetails_left__fjtag"};